/**
 * @file Whether a settled answer says nothing new over the one on screen: the
 * same answer once each result's `snapshotId` is set aside. Consumer:
 * `useAnalyticsAnswer`, which skips the write when this holds, so a refetch
 * that read the same builds and rows re-renders nothing. `snapshotId` is the
 * lake's, and it moves on every lake commit whether or not a fact build ran;
 * the builds' provenance is what moves only with new data.
 */
import { isEqual, omit } from 'lodash';
import type { Snapshot } from 'valtio';

import type { AnalyticsAnswer, AnalyticsSettledAnswer } from './index.types';

export const analyticsAnswerUnchanged = (
  shown: Snapshot<AnalyticsAnswer> | undefined,
  next: AnalyticsSettledAnswer,
): boolean =>
  shown?.status === 'answered' && next.status === 'answered'
    ? isEqual(omit(shown.result, 'snapshotId'), omit(next.result, 'snapshotId'))
    : isEqual(shown, next);
